import { render, staticRenderFns } from "./approval-reimbursement.vue?vue&type=template&id=55296a2e&scoped=true"
import script from "./approval-reimbursement.vue?vue&type=script&lang=js"
export * from "./approval-reimbursement.vue?vue&type=script&lang=js"
import style0 from "./approval-reimbursement.vue?vue&type=style&index=0&id=55296a2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55296a2e",
  null
  
)

export default component.exports